module.exports = __webpack_public_path__ + "img/NWTULogoTransparent300x291.964b42f1.png";